import { MarkdownParser } from "../MarkdownParser";
import * as React from 'react';

import { DismissButton } from "./DismissButton";
import { BadgeContainer, BadgeDismissingCard, Container, Text, Wrap } from "./styles";












export const SubscriptionBadge = ({
  className,
  onClick,
  onDismiss,
  children,
  icon,
  bodyTemplate,
  dismissedText,
  undoButtonText }) => /*#__PURE__*/

React.createElement(Container, { className: className }, /*#__PURE__*/
React.createElement(BadgeDismissingCard, {
  dismissedText: dismissedText,
  undoButtonText: undoButtonText,
  onDismiss: onDismiss }, /*#__PURE__*/

React.createElement(BadgeContainer, null, /*#__PURE__*/
React.createElement(Wrap, { onClick: onClick },
icon, /*#__PURE__*/
React.createElement(Text, null, /*#__PURE__*/
React.createElement(MarkdownParser, null, bodyTemplate))), /*#__PURE__*/



React.createElement(DismissButton, null))),


children);